import { render } from "./FormVille.vue?vue&type=template&id=48ba3f31"
import script from "./FormVille.vue?vue&type=script&lang=js"
export * from "./FormVille.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__